import { ModalContext } from "apps/portal/src/providers";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { Button, MenuPopover } from "../../../atoms";
import { CreditCardUpIcon } from "../../../atoms/icons/CreditCardUpIcon";
import { PencilIcon } from "../../../atoms/icons/PencilIcon";
import EnterVoucherCodeModal from "./EnterVoucherCodeModal";

const TopUpActionsMenuPopover = ({ memberId }: { memberId: string }) => {
  const { t } = useTranslation();
  const { stackModal } = useContext(ModalContext);
  const options = [
    {
      id: "voucher",
      label: t("components.userWallets.topUp.items.enterTheVoucherCode"),
      classNameLabel: "text-gray-950",
      icon: <PencilIcon className="size-5" />,
      onClick: () => {
        stackModal(<EnterVoucherCodeModal memberId={memberId} />);
      },
    },
  ];
  return (
    <MenuPopover
      classNameContent="w-48"
      triggerButton={
        <Button className="flex flex-row items-center justify-between gap-2">
          <CreditCardUpIcon pathClassName="dark:stroke-gray-0" />
          <div className="dark:text-gray-0  text-nowrap text-base font-semibold text-gray-950">
            {t("page.userWallets.walletCard.topUpCta")}
          </div>
        </Button>
      }
      options={options}
    />
  );
};

export default TopUpActionsMenuPopover;
